import { PersonalDetails } from "./reducer/types";
import {
  PersonalDetailsMasked,
  PersonalDetailsResponse,
} from "./response/response";

export const extractPersonalDetails = (
  details: PersonalDetailsResponse | PersonalDetailsMasked,
): PersonalDetails => {
  const address = details.mailing || details.residential;

  return {
    email: details.email,
    address:
      typeof address === "string"
        ? address
        : {
            ...address,
            postCode: address.post_code,
          },
  };
};
